// Filename: collections/activitys
define('collections/template/calendar/template-sessions',[
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // Pull in the Model module from above
    'models/template/calendar/template-session'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // model
    MTemplateSession
) {

    var CTemplateSession = Backbone.Collection.extend({
        model: MTemplateSession,

        onNewModel: function(model) {
            if (!model.id) {
                var lastSession = this.last(),
                    id = lastSession ? '@' + (parseInt(lastSession.id.replace('@', '')) + 1) : '@0';
                model.id = id;
                model.set('_id', model.id);
            }
        },

        getInvalidSessions: function () {
            var names = [];
            this.each(function (session) {
                session.getExercises().forEach(function (exercise) {
                    if (exercise._animation.name === "" && ! names.includes(this.get('name'))) {
                        names.push(this.get('name'));
                    }
                }, session);
            });
            return names;
        },

        any: function() {
            return this.models.length;
        }

    });

    return CTemplateSession;
});

